// src/stores/auth.js
import { defineStore } from 'pinia'
import { api } from 'boot/axios'

export const useAuth = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token') || null,
    me: JSON.parse(localStorage.getItem('me') || 'null'),
  }),
  getters: {
    isAuthenticated: (s) => !!s.token,
  },
  actions: {
    async login(username, password) {
      const { data } = await api.post('/auth/login', { username, password })
      this.token = data.access_token
      localStorage.setItem('token', data.access_token)
      await this.fetchMe()
    },
    async fetchMe() {
      // Prefer users endpoint for richer/me profile
      const { data } = await api.get('/users/me')
      this.me = data
      localStorage.setItem('me', JSON.stringify(data))
    },
    async updateMe(payload) {
      // Accept either plain object or FormData; if object, convert to FormData
      let form
      if (payload instanceof FormData) {
        form = payload
      } else {
        form = new FormData()
        Object.entries(payload || {}).forEach(([k, v]) => {
          if (v !== undefined && v !== null) form.append(k, v)
        })
      }
      const { data } = await api.put('/users/me', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      this.me = data
      localStorage.setItem('me', JSON.stringify(data))
      return data
    },
    async logout() {
      try {
        await api.post('/auth/logout')
      } catch {
        // ignore network/server error on logout; proceed to clear local state
      }
      this.token = null
      this.me = null
      localStorage.removeItem('token')
      localStorage.removeItem('me')
    },
  },
})
